{
  "open": "Assistant",
  "openUnread": "Assistant: {{n}} new answers",
  "openWaiting": "Assistant: {{n}} waiting for your decision",
  "title": "Assistant",
  "close": "Close",
  "expand": "Expand",
  "collapse": "Collapse",
  "back": "To conversations",
  "resize": "Width of the assistant panel",
  "loading": "Loading the conversation…",
  "thinking": "Thinking…",
  "readOnly": "Read only",
  "mode": {
    "change": "Changes allowed for {{hours}}\u00a0h {{minutes}}\u00a0min",
    "changeMinutes": "Changes allowed for {{minutes}}\u00a0min",
    "changeShort": "{{hours}}\u00a0h {{minutes}}\u00a0min",
    "changeMinutesShort": "{{minutes}}\u00a0min"
  },
  "cards": {
    "label": "Change: {{title}}",
    "where": "Project: {{project}}",
    "target": "{{target}}",
    "risk": {
      "operate": "Risk: operate",
      "change": "Risk: change",
      "create": "Risk: create",
      "destroy": "Risk: delete",
      "dangerous": "Dangerous command",
      "destructive": "Removes or changes"
    },
    "cost": "≈ {{monthly}} {{currency}} per month, {{toMonthEnd}} {{currency}} until the month ends",
    "budget": {
      "blocked_new": "The project's budget ({{budget}} {{currency}}) is reached: the panel will not create a new paid service.",
      "blocked_change": "This takes the forecast beyond the budget with its margin ({{limit}} {{currency}}): the panel will refuse it.",
      "raise": "Request a budget raise",
      "adminWarning": "This goes over the project's budget. As an administrator you may still run it; going over is audited."
    },
    "interrupts": {
      "restart": "The server restarts.",
      "power_off": "The server powers off.",
      "needs_off": "Works only on a powered-off server.",
      "disk_overwritten": "Everything on the server's disk is replaced.",
      "traffic": "Connections may drop.",
      "data_loss": "Deleted for good."
    },
    "warnings": {
      "systemctl_restart": "The service is unavailable while it restarts.",
      "systemctl_reload": "The service rereads its configuration; a broken configuration may stop it.",
      "systemctl_start": "The service starts and may open ports.",
      "systemctl_stop": "The service stays stopped until it is started again.",
      "docker_restart": "The container restarts; its connections drop.",
      "packages_upgrade_security": "Only the security updates are installed as root, not a full upgrade; services using them may restart.",
      "package_install": "Software is installed as root from the distribution's repositories.",
      "firewall_allow": "The port becomes reachable from the internet (if the cloud firewall allows it too).",
      "firewall_deny": "Connections to the port are refused from now on.",
      "nginx_test_reload": "nginx reloads only when its configuration test passes.",
      "logrotate_force": "Logs are rotated now."
    },
    "role": "The server's Autopilot role: {{role}}",
    "details": "Details",
    "typeName": "To delete, type «{{name}}»",
    "stepUp": "Confirm with your second factor: changes through the assistant are then allowed in this browser for {{hours}}\u00a0h or until you sign out. Each change still waits for your button.",
    "stepUpEvery": "Your organisation confirms every change with the second factor.",
    "cancel": "Cancel",
    "otherSession": "It can only be confirmed in the browser where the card appeared.",
    "reject": "Reject",
    "run": "Run",
    "running": "Running…",
    "done": "Done.",
    "operation": "The operation started; its progress is in the project's operations.",
    "failed": "Not done.",
    "rejected": "Rejected. Nothing ran.",
    "expired": "The card expired. Nothing ran.",
    "terminalLabel": "A command for the terminal on {{server}}",
    "terminalLead": "The assistant does not run this command: insert it into your terminal on {{server}} (without Enter) or copy it — read it and run it yourself.",
    "terminalClosed": "Open a terminal on {{server}} to insert the command.",
    "terminalWhere": "In your terminal {{name}}",
    "terminalWrite": "The command changes the system: the assistant types it into your terminal when you press «Run».",
    "terminalDangerous": "A dangerous command: it may delete data, cut off access to the server or stop it. Confirm with your second factor.",
    "terminalDestructive": "The command removes, overwrites, stops or substantially changes something: the assistant types it into your terminal only when you press «Run» — in «Auto» too.",
    "effect": "What will be removed or changed: {{effect}}",
    "stepUpDangerous": "A dangerous command is confirmed with your second factor, for this card on its own."
  },
  "newAbout": "New conversation about {{name}}",
  "newConversation": "New conversation",
  "organization": "Whole organisation",
  "retention": "Only you see your conversations; they are kept 90 days after the last message.",
  "today": "today {{used}} of {{limit}} messages",
  "injection": "The server's data held text with instructions for an AI; I did not follow them.",
  "stopped": "Stopped",
  "copy": "Copy",
  "copied": "Copied",
  "ask": {
    "button": "Ask the assistant",
    "aboutRule": "Ask the assistant about this rule",
    "error": "What does this error mean and how do I fix it?",
    "operation": "Why did this operation fail and what should I do?",
    "alert": "What did this alert mean and was anything wrong?",
    "alertFiring": "Why is this alert firing and how do I fix it?",
    "firewallRule": "What does this rule allow, and is it safe?",
    "selectionName": "Selected in the terminal of {{server}}"
  },
  "server": {
    "button": "Assistant",
    "open": "Ask the assistant about this server",
    "withCount": "Assistant: conversations about this server — {{count}}"
  },
  "screen": {
    "chip": {
      "terminal": "Terminal {{server}}",
      "console": "Console {{server}}",
      "desktop": "Desktop {{server}}"
    },
    "sent": "A snapshot of the screen taken when the message was sent",
    "newLines": "{{name}} · new lines"
  },
  "offer": {
    "switchTo": "Go to the conversation about {{name}}",
    "newAbout": "New conversation about {{name}}"
  },
  "attach": {
    "button": "Attach a log or a screenshot",
    "pending": "To be sent with the message",
    "sent": "Attached",
    "pasted": "Pasted text",
    "uploading": "Uploading…",
    "remove": "Remove “{{name}}”",
    "injection": "The attachment held text with instructions for an AI; the assistant does not follow them."
  },
  "operator": {
    "title": "Installation usage in {{month}}",
    "lead": "Every organisation of this installation; you see it as its operator.",
    "limit": "{{used}} of {{limit}} tokens this month ({{percent}}\u00a0%).",
    "noLimit": "{{used}} tokens this month; the installation has no monthly cap.",
    "empty": "Nobody used the assistant this month.",
    "organization": "Organisation",
    "people": "People"
  },
  "chips": {
    "error": "Error: {{label}}"
  },
  "switcher": {
    "title": "Conversations",
    "search": "Find a conversation",
    "new": "New conversation",
    "all": "All conversations →",
    "thinking": "thinking…",
    "waiting": "waiting for you",
    "unread": "New answer",
    "empty": "No conversations yet",
    "about": "About {{name}}",
    "clearFilter": "Show all conversations"
  },
  "list": {
    "rename": "Conversation title",
    "renameThis": "Rename “{{title}}”",
    "save": "Save the title",
    "delete": "Delete",
    "deleteThis": "Delete “{{title}}”",
    "deleteTitle": "Delete the conversation “{{title}}”?",
    "deleteConsequence": "Its texts are deleted; the audit log of what the assistant looked at stays."
  },
  "empty": {
    "lead": "I see your projects' resources with your rights. I propose changes as a card; they run only when you press «Run». Ask about the panel, Linux, networking, Docker, databases and code."
  },
  "suggestions": {
    "label": "Where to start",
    "serverDown": "Why is the server not responding?",
    "serverLoad": "What keeps the server busy: CPU, disk, network?",
    "openPort": "How do I open port 443?",
    "monthCost": "How much will I spend this month?",
    "cheaper": "Where can I save?",
    "budget": "Will the budget last until the end of the month?",
    "firewallCheck": "Which ports does this firewall open?",
    "sshOnly": "How do I allow SSH from my address only?",
    "privateNetwork": "How do I attach a server to a private network?",
    "balancer502": "Why does the load balancer return 502?"
  },
  "composer": {
    "label": "Message to the assistant",
    "placeholder": "Ask about servers, networks, costs…",
    "send": "Send",
    "stop": "Stop the answer",
    "hint": "Enter sends, Shift+Enter starts a new line",
    "mistakes": "Autopilot can make mistakes."
  },
  "refusal": {
    "out_of_scope": "Off topic",
    "disallowed": "Not something I help with",
    "model": "The model declined"
  },
  "tool": {
    "get": "Looked at the {{what}} {{target}}",
    "list": "Looked at: {{what}}",
    "help": "Searched the help: “{{query}}”",
    "proposal": "Prepared a change for you to confirm",
    "explain": "Looked up the error “{{reason}}”",
    "estimate": "Estimated the cost of the change",
    "error": "failed",
    "denied": "no access",
    "request": "Request ({{tool}})",
    "result": "Answer",
    "load": "Took tools: {{what}}",
    "pair": "Ran in terminal {{target}}: {{command}}",
    "pairRunning": "Running in the terminal: {{command}}",
    "pairRefused": "Not typed into the terminal: {{command}}"
  },
  "groups": {
    "servers": "server",
    "networks": "network",
    "firewalls": "firewall",
    "volumes": "volumes",
    "load_balancers": "load balancer",
    "certificates": "certificates",
    "floating_ips": "floating IPs",
    "public_ips": "public IPs",
    "placement_groups": "placement groups",
    "images": "snapshots and backups",
    "ssh_keys": "SSH keys",
    "costs": "costs",
    "budgets": "budget",
    "alerts": "alerts",
    "autopilot": "Autopilot",
    "operations": "operations",
    "activities": "activity",
    "catalogue": "catalogue",
    "projects": "projects",
    "notifications": "notifications",
    "terminal": "terminal",
    "errors": "errors",
    "resources": "resources"
  },
  "setup": {
    "title": "Switch the assistant on",
    "lead": "The assistant answers questions about servers, infrastructure and development and looks at the projects' resources with the rights of whoever asks. Before switching it on, accept the data notice:",
    "notice": {
      "sent": "Messages, the page's context and tool results are sent to the model provider (Anthropic).",
      "provider": "The provider processes them under its API terms.",
      "redacted": "Passwords, keys and tokens are hidden before sending; credentials never reach the model.",
      "kept": "Only their author sees conversations; we keep them 90 days after the last message. Administrators see usage and the audit log, not the texts."
    },
    "accept": "Accept and switch on"
  },
  "settings": {
    "title": "Assistant settings",
    "open": "Assistant settings",
    "back": "Back to the conversation",
    "enabled": "Assistant switched on",
    "projects": "Where it works",
    "allProjects": "In every project",
    "perMinute": "Messages per minute per person",
    "perDay": "Messages per day per person",
    "tokensPerDay": "Tokens per day per person",
    "monthly": "Tokens per month for the organisation",
    "monthlyHint": "Empty: no cap of its own",
    "notice": "Data notice accepted {{date}}",
    "models": "Models: {{chat}} (hard questions), {{fast}} (simple ones), topic filter {{filter}}",
    "save": "Save",
    "saved": "Saved",
    "usage": "Usage in {{month}}",
    "costHint": "An estimate in euros at the provider's price list; nothing is charged.",
    "noUsage": "Nobody used the assistant this month.",
    "person": "Person",
    "messages": "Messages",
    "tokens": "Tokens",
    "cost": "Estimate",
    "total": "Total",
    "changes": "Changes through the assistant",
    "allowChanges": "Allow changes from confirmation cards",
    "windowHours": "Hours a second factor allows changes for",
    "windowHint": "1 to 12 hours; signing out ends them at once.",
    "stepUpEveryChange": "Ask for the second factor on every change",
    "style": "Default answer style",
    "styleHint": {
      "brief": "Up to 5–7 lines: the point and the action first, details on request.",
      "standard": "Normal length: the point, then the steps and the reasons."
    },
    "styleOwn": "This is the default; everyone can choose their own in their assistant settings.",
    "model": "Model",
    "modelMode": {
      "auto": "Auto",
      "economy": "Economy",
      "quality": "Quality"
    },
    "modelHint": {
      "auto": "{{fast}} for simple answers, {{chat}} for changes, screenshots and diagnoses.",
      "economy": "Always {{fast}}: cheaper, weaker on hard questions.",
      "quality": "Always {{chat}}: dearer."
    },
    "byModel": "Usage by model",
    "modelColumn": "Model",
    "answers": "Answers",
    "terminalMax": "The highest Autopilot access to terminals",
    "terminalMaxHint": "Each person chooses the Autopilot's access to their own terminal, with their second factor, up to this level. «Off» forbids working in the terminals of the whole organisation; lowering it brings open sessions down at once.",
    "mine": "My settings",
    "organization": "Organisation",
    "terminalDefault": "Autopilot's access to new terminals",
    "panelDefault": "Actions in the panel by default",
    "panelDefaultHint": {
      "read": "After each change from a card, back to read only: the next one asks the second factor.",
      "change": "The second factor allows changes from cards for {{hours}}\u00a0h."
    },
    "hints": "Show hints",
    "voice": "Voice input",
    "voiceHint": "A microphone button in the input. Your browser recognises the speech (the sound goes to Google or Apple); the text lands in the input and is not sent by itself.",
    "voiceUnsupported": "This browser does not recognise speech: there is no microphone button."
  },
  "command": {
    "insert": "Insert into terminal",
    "insertHint": "Insert into {{name}} without Enter — read it and run it yourself",
    "run": "Run in terminal",
    "runHint": "Ask the Autopilot to run it in {{name}}",
    "runAsk": "Run in the terminal:\n```\n{{command}}\n```",
    "runEvent": "▶ Run by the button: {{command}}",
    "noTerminal": "Open a terminal to the server",
    "busy": "Wait for the answer to finish",
    "runAccess": "Give Autopilot access to {{name}} and run",
    "raiseFirst": "Autopilot has no access to this terminal. Choose a level and the command runs right after."
  },
  "focus": {
    "switched": "Switched from {{from}} to {{to}}"
  },
  "style": {
    "label": "Answer style",
    "brief": "Brief",
    "standard": "Standard"
  },
  "toolGroups": {
    "servers": "servers",
    "network": "networks and load balancers",
    "firewalls": "firewalls",
    "storage": "volumes and snapshots",
    "ips": "IP addresses",
    "costs": "costs and budget",
    "autopilot": "Autopilot",
    "alerts": "alerts",
    "access": "keys",
    "operations": "operations",
    "other": "everything else"
  },
  "pair": {
    "running": "The Autopilot runs: {{command}}",
    "stop": "Stop",
    "stopLabel": "Stop the Autopilot in the terminal {{name}}"
  },
  "access": {
    "title": "Autopilot's access to the terminal",
    "label": "Autopilot's access to the terminal: {{target}} · {{level}}",
    "labelNone": "Autopilot's access to the terminal: no terminal open",
    "noTerminal": "No terminal open",
    "noTerminalHint": "Open a terminal (SSH) to a server of this project to give the Autopilot access. Without one the chat works on the panel's data.",
    "pairOff": "Working in the terminal is off for the organisation or the project",
    "aboveMax": "Higher than the organisation allows",
    "levels": {
      "off": "Off",
      "read": "Read only",
      "moderated": "Moderated changes",
      "auto": "Auto"
    },
    "hints": {
      "off": "The Autopilot does not see this terminal and types nothing into it.",
      "read": "It sees the screen and your selection; it runs only commands that change nothing.",
      "moderated": "It looks around itself; commands that change the system run only after your click on the card.",
      "auto": "It installs packages, restarts services and creates files itself; anything that removes, overwrites or stops waits for your click, dangerous commands for your second factor too."
    },
    "intro": "Here you decide what the Autopilot may do in the open terminal, from «Off» to «Auto». The level holds for this session; switching it on asks your second factor. Below are the panel's actions: read only, or changes for a while after the second factor.",
    "introDone": "Got it",
    "panel": "Actions in the panel",
    "changes": "Changes",
    "changesOff": "The organisation does not allow changes through the assistant",
    "panelHints": {
      "read": "The assistant looks with your rights; it proposes a change as a card.",
      "change": "The second factor allows changes from cards for a while; each still waits for your click."
    },
    "short": {
      "off": "Off",
      "read": "Read",
      "moderated": "Moderated",
      "auto": "Auto"
    },
    "noTerminalShort": "No terminal"
  },
  "quote": {
    "label": "The selection in the terminal {{server}} ({{count}} lines) goes with the message",
    "remove": "Do not send the selection"
  },
  "nearLimit": "Messages left for today: {{left}} of {{limit}}",
  "clouds": {
    "label": "Goes with the message",
    "terminalScreen": "Terminal {{name}}: its screen and selection go with the message",
    "session": "Session {{name}}: Autopilot knows which server you mean",
    "page": "{{name}}: Autopilot knows what the page is about",
    "selection": "Selected, lines: {{count}}"
  },
  "voice": {
    "button": "Voice input",
    "recording": "Recording — Esc or the microphone button stops it",
    "notice": "Speech is recognised by your browser: the sound goes to Google or Apple",
    "noticeDone": "Got it",
    "refused": "The browser did not allow the microphone"
  }
}
